import {useTranslation} from "react-i18next";

const ListDetailsNotes = ({ order }) => {
    const { t } = useTranslation()
    return (
        <div className="">
            <div className="max-w-7xl mx-auto px-2 pt-2">
                <div className="py-3 flex">
                    <dt className="text-sm font-medium text-gray-500">
                        {t('Notes')}
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 text-red-600 ml-4 font-bold">
                        {order.comment}
                    </dd>
                </div>
            </div>
        </div>
    )
}

export default ListDetailsNotes
